<div class="px-4">
    <!-- <div class="bg-gradient-to-r from-blue-400 via-blue-500 to-purple-600 text-white rounded-md mx-2 mt-4 shadow-lg overflow-hidden transition-all duration-500 px-2">
        <div class="flex justify-between items-center p-4">
            <div>
                <h2 class="text-lg md:text-xl lg:text-2xl font-bold"> 
                    Machine Daily Shift Output
                </h2>

                <div class="flex flex-col md:flex-row md:items-center md:space-x-4 mt-1 text-sm space-y-2 md:space-y-0">
                    <span class="flex items-center space-x-1">
                        <i class="far fa-calendar-alt"></i>
                        <span>{{ getSelectedDepartmentName() }}</span>
                    </span>
                </div>
            </div>

            <div class="flex items-center gap-6">
                <div class="text-right">
                    <p class="font-bold">Live Dashboard</p>
                    <p class="text-xs">Auto-refresh every 5 minutes</p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="grid grid-cols-1 sm:grid-cols-1 xl:grid-cols-1 pb-4 items-start pt-0">
        <div class="bg-white rounded-lg mx-2 mt-2">
            <div class="pt-4 px-6">
                <div class="flex flex-col lg:flex-row items-center justify-between pb-4">
                    <div class="flex items-center space-x-4">
                        <select id="department" [ngModel]="department_id()" class="textField w-48"
                            (ngModelChange)="onDepartmentChange($event)">
                            <option [ngValue]="null" hidden disabled selected>Choose a Department</option>
                            @for (dept of $$departmentDTO(); track dept.departmentId) {
                            <option [ngValue]="dept.departmentId">
                                {{ dept.departmentName | titlecase }}
                            </option>
                            }
                        </select>
                    </div>

                    <div class="flex items-center space-x-2 mt-2 lg:mt-0 justify-end w-full lg:w-auto">

                        <select class="textField w-28" [(ngModel)]="selectedYear"
                            (change)="updateCalendarYear(selectedYear)">
                            @for (year of years; track year) {
                            <option [value]="year">{{ year }}</option>
                            }
                        </select>

                        <select class="textField w-32" [(ngModel)]="selectedMonth"
                            (change)="updateCalendarMonth(selectedMonth)">
                            @for (month of months; track $index) {
                            <option [value]="$index">{{ month }}</option>
                            }
                        </select>

                        <div class="flex space-x-2">
                            <button class="button-blue" (click)="previousWeek()" [disabled]="startDayIndex() === 0">
                                Previous
                            </button>
                            <button class="button-blue" (click)="nextWeek()"
                                [disabled]="startDayIndex() + 7 >= daysInCurrentMonth">
                                Next
                            </button>
                        </div>

                    </div>

                </div>
            </div>
            <div>
                <div>
                    <div class="overflow-y-auto scrollbar-hide" style="max-height: 725px;">
                        <table class="table w-full">
                            <thead class="sticky top-0 z-20 bg-gray-200">
                                <tr>
                                    <th class="px-6 py-3 sticky left-0 z-10 bg-gray-200">Machines</th>
                                    <th class="px-2 py-3 sticky left-0 z-9 w-32">Shift</th>
                                    <th class="md:px-2 px-6 py-3 text-center" *ngFor="let day of calendarDays">
                                        <div class="flex flex-col">
                                            <span class="font-medium">{{ day | date: 'MMM d' }}</span>
                                            <span class="text-xs text-gray-500 font-normal">{{ day | date: 'EEEE'
                                                }}</span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (dep of $$DepartmentOutput(); track dep) {
                                @for (machine of dep.machines; track machine) {
                                <tr class="border-b border-b-gray-300">
                                    <td class="px-6 py-2 text-sm font-bold sticky left-0 z-10 w-16 bg-white">
                                        {{ machine.machineName }}
                                    </td>
                                    <td class="px-2 sticky left-0 z-9 relative w-32 h-full">
                                        <div class="h-full flex flex-col gap-4">
                                            @for (shift of $$ShiftsByMachine().get(machine.machineId) ?? []; track
                                            shift.shiftId) {
                                            <div class="flex-1 flex items-center">
                                                <span class="text-xs text-gray-500">{{ shift.shiftName }}</span>
                                            </div>
                                            }
                                        </div>
                                    </td>
                                    <td *ngFor="let day of calendarDays" class="w-32 border border-b-gray-300">
                                        <div class="flex flex-col h-full">
                                            @for (shift of $$ShiftsByMachine().get(machine.machineId) ?? []; track
                                            shift.shiftId) {
                                            <div
                                                class="flex items-center justify-center text-base font-semibold px-2 py-2 border-b last:border-b-0">
                                                <span (click)="onShiftCellClick(machine, day, shift.shiftId)" [ngClass]="{
                                                            'inline-block relative z-0 transition-transform duration-200 ease-in-out': true,
                                                            'bg-blue-200 text-gray-700 px-4 rounded-lg cursor-pointer hover:scale-125 hover:z-50 hover:shadow-lg': getShiftOutput(getShiftData(machine, day), shift.shiftId) !== '-',
                                                            'cursor-default': getShiftOutput(getShiftData(machine, day), shift.shiftId) === '-'
                                                        }">
                                                    {{ getShiftOutput(getShiftData(machine, day), shift.shiftId) }}
                                                </span>
                                                @if (getShiftChangeovers(getShiftData(machine, day), shift.shiftId) > 0)
                                                {
                                                <span
                                                    class="text-xs font-semibold bg-red-100 text-gray-700 px-2 py-1 rounded-lg ml-2"
                                                    (click)="onShiftCellClick(machine, day, shift.shiftId)"
                                                    title="Changeovers">
                                                    {{ getShiftChangeovers(getShiftData(machine, day), shift.shiftId) }}
                                                </span>
                                                }
                                                @if (getMakeReadyCountNum(getShiftData(machine, day), shift.shiftId) > 0)
                                                {
                                                <span
                                                    class="text-xs font-semibold bg-red-100 text-gray-700 px-2 py-1 rounded-lg ml-2"
                                                    (click)="onShiftCellClick(machine, day, shift.shiftId)"
                                                    title="Make Ready">
                                                    MR-{{ getMakeReadyCount(getShiftData(machine, day), shift.shiftId)
                                                    }}
                                                </span>
                                                }
                                            </div>
                                            }
                                        </div>
                                    </td>
                                </tr>
                                }
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 pb-4 px-2">
            @for (unitChart of $$unitCharts(); track unitChart.unit) {
            <div class="bg-white rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 flex items-center py-2 px-4">
                    <span>Monthly {{ unitChart.unit }} Machine Output</span>
                </h3>
                <div class="pt-2 px-4">
                    <apx-chart [series]="unitChart.chartOptions.series" [chart]="unitChart.chartOptions.chart"
                        [xaxis]="unitChart.chartOptions.xaxis" [yaxis]="unitChart.chartOptions.yaxis"
                        [dataLabels]="unitChart.chartOptions.dataLabels" [grid]="unitChart.chartOptions.grid"
                        [stroke]="unitChart.chartOptions.stroke" [tooltip]="unitChart.chartOptions.tooltip"
                        [legend]="unitChart.chartOptions.legend"></apx-chart>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="bg-white rounded-lg mx-2 p-4 mb-4">
        <h3 class="text-lg font-semibold text-gray-900 flex items-center py-2 px-4">
            <span>Weekly Machine Output</span>
        </h3>
        <div class="pt-2 px-4">
            <apx-chart #weeklyChart [series]="weeklyChartOptions.series" [chart]="weeklyChartOptions.chart"
                [xaxis]="weeklyChartOptions.xaxis" [yaxis]="weeklyChartOptions.yaxis"
                [dataLabels]="weeklyChartOptions.dataLabels" [grid]="weeklyChartOptions.grid"
                [stroke]="weeklyChartOptions.stroke" [tooltip]="weeklyChartOptions.tooltip"
                [legend]="weeklyChartOptions.legend"></apx-chart>
        </div>
    </div>
</div>

@if (showOperationsPopup()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    (click)="closeOperationsPopup()">
    <div class="bg-white rounded-lg shadow-xl w-11/12 max-w-4xl max-h-[90vh] overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 text-white">
            <div class="flex justify-between items-start">
                <div>
                    <h2 class="text-2xl font-bold mb-1">Shift Operations</h2>
                    <div class="text-sm">
                        {{ selectedShiftInfo().machineName }} / {{ selectedShiftInfo().shiftName }} / {{
                        selectedShiftInfo().date }}
                        <span
                            class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
                            {{ operatorNames() }}
                        </span>
                    </div>
                    <div class="pt-2 text-base flex gap-3">
                        Changeovers: <strong>{{ selectedOperations().length }}</strong>

                    </div>

                </div>
                <button (click)="closeOperationsPopup()"
                    class="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors"
                    aria-label="Close">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </button>
            </div>
        </div>

        <div class="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
            @if (selectedOperations().length > 0) {
            <div class="space-y-3">
                @for (operation of selectedOperations(); track operation.operationId; let i = $index) {
                <div class="rounded-lg p-4 border hover:shadow-md transition-shadow cursor-pointer"
                     [ngClass]="{
                        'bg-amber-50 border-amber-300': operation.makeReadyCount > 0 && (!operation.totalSheets || operation.totalSheets === 0),
                        'bg-gray-50 border-gray-200': !(operation.makeReadyCount > 0 && (!operation.totalSheets || operation.totalSheets === 0))
                     }"
                     (click)="toggleJobDetails(operation)">

                    <div class="flex items-center justify-between mb-3">
                        <div class="flex items-center space-x-3">
                            <div
                                class="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-semibold text-sm">
                                {{ i + 1 }}
                            </div>
                            <h3 class="font-semibold text-gray-900 text-lg flex items-center gap-2">
                                {{ operation.jobNo }}
                                <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-200 text-gray-800 ml-1">
                                    Pass {{ operation.jobPassNumber || '-' }}
                                </span>
                                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border"
                                      [ngClass]="{
                                        'bg-green-100 text-green-800 border-green-200': operation.jobStatus.toLowerCase() === 'completed',
                                        'bg-red-100 text-red-800 border-red-200': operation.jobStatus.toLowerCase() === 'hold',
                                        'bg-yellow-100 text-yellow-800 border-yellow-200': operation.jobStatus.toLowerCase() === 'idle',
                                        'bg-blue-100 text-blue-800 border-blue-200': operation.jobStatus.toLowerCase() === 'in progress',
                                        'bg-gray-100 text-gray-800 border-gray-200': !operation.jobStatus || (operation.jobStatus.toLowerCase() !== 'completed' && operation.jobStatus.toLowerCase() !== 'hold' && operation.jobStatus.toLowerCase() !== 'idle' && operation.jobStatus.toLowerCase() !== 'in progress')
                                      }">
                                    {{ (operation.jobStatus || 'Unknown') | titlecase }}
                                </span>
                            </h3>
                        </div>

                        <span
                            class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
                            Output: {{ operation.totalSheets | number }} | MR: {{ operation.makeReadyCount | number }}
                            @if (operation.makeReadyHours > 0) {
                                | MR Time: {{ formatMakeReadyHours(operation.makeReadyHours) }}
                            }
                        </span>
                    </div>

                    <div class="grid grid-cols-2 gap-3 mt-2">
                        <div>
                            <!-- <p class="text-xs text-gray-500 uppercase tracking-wide mb-1">Description</p> -->
                            <p class="text-xs text-gray-900 font-medium">{{ operation.jobDescription || '-' }}</p>
                        </div>
                        <div>
                            <!-- <p class="text-xs text-gray-500 uppercase tracking-wide mb-1">Customer</p> -->
                            <p class="text-xs text-gray-900 font-medium">{{ operation.customer || '-' }}</p>
                        </div>
                        <div>
                            <p class="text-xs text-gray-500 uppercase tracking-wide">Started</p>
                            <p class="text-xs text-gray-900 font-medium">{{ operation.startedDateTime ? (operation.startedDateTime | date:'short') : '-' }}</p>
                        </div>
                        <div>
                            <p class="text-xs text-gray-500 uppercase tracking-wide">Completed</p>
                            <p class="text-xs text-gray-900 font-medium">{{ operation.completedDateTime ? (operation.completedDateTime | date:'short') : '-' }}</p>
                        </div>
                    </div>

                    @if (operation.operators && operation.operators.length > 0) {
                    <div class="mt-3">
                        <div class="flex flex-wrap gap-2">
                            @for (op of operation.operators; track op.operatorId) {
                            <span
                                class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-indigo-50 text-indigo-800">
                                <span>{{ op.operatorName }}</span>
                                <span class="text-indigo-500">({{ op.operatorEmpNo }})</span>
                                <span class="ml-1 font-semibold">— {{ op.output | number }}</span>
                            </span>
                            }
                        </div>
                    </div>
                    }

                    @if (expandedOperationId() === operation.operationId) {
                    <div class="mt-4 pt-3 border-t border-gray-200" (click)="$event.stopPropagation()">
                        @if (loadingHoldReasons()[operation.operationId]) {
                            <div class="flex justify-center py-4">
                                <svg class="animate-spin h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        } @else if (holdReasons()[operation.operationId] && holdReasons()[operation.operationId].length > 0) {
                            <div class="space-y-2">
                                @for (reason of holdReasons()[operation.operationId]; track $index) {
                                    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                                        <div class="flex items-center gap-2">
                                            <span class="bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-0.5 rounded border border-red-200">
                                                {{ reason.holdReason }}
                                            </span>
                                            @if (reason.plateCount && reason.plateCount > 0) {
                                                <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded border border-blue-200">
                                                    Plates Changed: {{ reason.plateCount }}
                                                </span>
                                            }
                                        </div>
                                        <div class="text-xs text-gray-500 flex items-center gap-3">
                                            <span class="font-medium text-gray-700">{{ reason.pausedAt | date:'MMM d, h:mm a' }}</span>
                                            <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                                            <span class="font-medium text-gray-700">{{ reason.resumedAt ? (reason.resumedAt | date:'MMM d, h:mm a') : 'Ongoing' }}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="text-center">
                                <p class="text-sm text-gray-500 italic">No hold reasons recorded for this job.</p>
                            </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>
            } @else {
            <div class="text-center py-12">
                <svg class="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2">
                    </path>
                </svg>
                <p class="text-gray-500 text-lg">No operations found for this shift</p>
            </div>
            }
        </div>
    </div>
</div>
}